import Headline, { type Props } from "./Headline";

export default function H2({size = "2xl", ...props}:Props) {
  return <Headline tag="h2" size={size} {...props}/>;
}